import React from 'react'
import { createRoot } from 'react-dom/client'
import { initSentry } from './utils/sentry'
import App from './App.tsx'
import './index.css'

// Initialize Sentry before rendering
initSentry();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
